export default __webpack_public_path__ + "static/media/mobile_banking.593a3681.svg";